// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import { joyoKanji } from "./joyoKanji";
import { joyoKanjiMeanings } from "./joyoKanjiMeanings";
import { jinmeiyoKanji } from "./jinmeiyoKanji";
import { jinmeiyoKanjiMeanings } from "./jinmeiyoKanjiMeanings";
import { kanjiJlptLevels } from "./kanjiJlptLevels";

export const joyoKanjiMeaningsWithJlpt = joyoKanjiMeanings.map((entry) => ({
    ...entry,
    jlptLevel: kanjiJlptLevels[entry.symbol] ?? null,
}));

// Every kanji covered by the site's reference: jōyō (JLPT-tagged) plus
// jinmeiyō (untagged, since they aren't tested on the JLPT).
export const allKanjiMeanings = [...joyoKanjiMeaningsWithJlpt, ...jinmeiyoKanjiMeanings];
export const totalKanjiCount = joyoKanji.length + jinmeiyoKanji.length;
